import { EntityUpdate } from "components/ManageTags/types";

type WasteStreamTagsRow = { id: string; tags: readonly { name: string }[] };

/**
 * The add and remove lists for `updateWasteStreamTags`: a tag is added when a
 * stream gains it in the dialog and removed when a stream loses it.
 */
export function wasteStreamTagChanges(
  rows: readonly WasteStreamTagsRow[],
  updates: readonly EntityUpdate[]
): { tagsToAdd: string[]; tagsToRemove: string[] } {
  const tagsToAdd = new Set<string>();
  const tagsToRemove = new Set<string>();
  for (const update of updates) {
    const current = new Set(rows.find((row) => row.id === update.id)?.tags.map((t) => t.name));
    const next = new Set(update.tags);
    for (const tag of next) {
      if (!current.has(tag)) tagsToAdd.add(tag);
    }
    for (const tag of current) {
      if (!next.has(tag)) tagsToRemove.add(tag);
    }
  }
  return { tagsToAdd: [...tagsToAdd], tagsToRemove: [...tagsToRemove] };
}
